import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import axiosInstance from 'api/axios';
import { type MeterDetails } from 'interfaces/assets/Meters.interface';

export const useFetchMeterByConnectionPoint = (
  connectionPointIdClient?: string
): UseQueryResult<MeterDetails> => {
  return useQuery<MeterDetails>({
    queryKey: ['meterByConnectionPoint', connectionPointIdClient],
    queryFn: async () => {
      if (!connectionPointIdClient) return null;
      const response = await axiosInstance.get(
        `meter/by_connection_point/${connectionPointIdClient}`
      );
      return response.data;
    },
    enabled: !!connectionPointIdClient,
  });
};
